import React from "react";
import { exportAttendance } from "../Api/PayrollAttendanceservice";
import "../Styling/PayrollTheme.css";

const STATUS_MAP = {
  Present: "present",
  Absent: "absent",
  Leave: "leave",
  WeekOff: "weekoff",
  Holiday: "holiday",
  "Half Day": "halfday",
};

const getRowClass = (status) => {
  const key = STATUS_MAP[status];
  return key ? `pac-grid__row--${key}` : "";
};

const getBadgeClass = (status) => {
  const key = STATUS_MAP[status];
  return key ? `pac-grid__badge pac-grid__badge--${key}` : "pac-grid__badge";
};

const formatHours = (hours) => {
  if (hours === null || hours === undefined) return "—";
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return `${h}h ${m}m`;
};

const PayrollAttendanceGrid = ({
  data = [],
  page,
  pageSize,
  total,
  onPageChange,
  filters,
}) => {
  const totalPages = Math.ceil(total / pageSize) || 1;

  const exportCSV = async () => {
    if (!filters?.workingDaysId) return;
    try {
      const { page: _p, pageSize: _ps, ...cleanFilters } = filters;
      const fullData = await exportAttendance(cleanFilters);
      if (!fullData || fullData.length === 0) return;

      const headers = Object.keys(fullData[0]).join(",");
      const rows = fullData.map((d) => Object.values(d).join(",")).join("\n");
      const blob = new Blob([headers + "\n" + rows], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const hasFilters =
        cleanFilters.status ||
        cleanFilters.resourceName ||
        cleanFilters.resourceId ||
        cleanFilters.fromDate ||
        cleanFilters.toDate;

      const a = document.createElement("a");
      a.href = url;
      a.download = hasFilters
        ? "attendance_filtered.csv"
        : "attendance_full.csv";
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed", err);
    }
  };

  return (
    <div className="pac-grid__card">
      <div className="pac-grid__toolbar">
        <button className="pac-grid__export-btn" onClick={exportCSV}>
          ↓ Export CSV
        </button>
      </div>

      {/* Table */}
      <div className="pac-grid__scroll">
        <table className="pac-grid__table">
          <thead className="pac-grid__thead">
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Date</th>
              <th>Status</th>
              <th>Hours</th>
              <th>Leave Type</th>
              <th>Leave Qty</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={7} className="pac-grid__empty">
                  No records found
                </td>
              </tr>
            ) : (
              data.map((row, i) => (
                <tr key={i} className={getRowClass(row.status)}>
                  <td>{row.resourceId}</td>
                  <td>{row.resourceName}</td>
                  <td>{row.attendanceDate?.split("T")[0]}</td>
                  <td>
                    <span className={getBadgeClass(row.status)}>
                      {row.status}
                    </span>
                  </td>
                  <td>{formatHours(row.hoursWorked)}</td>
                  <td>{row.leaveType || "—"}</td>
                  <td>{row.leaveQty ?? "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="pac-grid__footer">
        <span className="pac-grid__page-info">
          Page {page} of {totalPages}
        </span>
        <div className="pac-grid__btn-group">
          <button
            className="pac-grid__page-btn"
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
          >
            ← Prev
          </button>
          <button
            className="pac-grid__page-btn"
            disabled={page === totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayrollAttendanceGrid;
